(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-area-6"] && !Shopify.designMode) return;
  try {
    
  /* ══ ABOUT — IntersectionObserver-driven CSS transitions ══ */
(function () {
    const portraitCol = document.getElementById('aboutPortraitCol');
    const contentCol = document.getElementById('aboutContentCol');
    const statBar = document.getElementById('aboutStatBar');
    const statItems = statBar ? statBar.querySelectorAll('.about-stat-item') : [];

    const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
            if (e.isIntersecting) {
                e.target.classList.add('revealed');
                io.unobserve(e.target);
            }
        });
    }, { threshold: .18 });

    if (portraitCol) io.observe(portraitCol);
    if (contentCol) io.observe(contentCol);

    // Stat bar items — individual observer
    const statIO = new IntersectionObserver((entries) => {
        entries.forEach(e => {
            if (e.isIntersecting) {
                e.target.classList.add('revealed');
                statIO.unobserve(e.target);
            }
        });
    }, { threshold: .3 });
    statItems.forEach(el => statIO.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer_12"] && !Shopify.designMode) return;
  try {
    
// Footer newsletter
if (window.innerWidth < 768) {
    document.querySelectorAll('.ft-accordion-btn').forEach(btn => {
        btn.addEventListener('click', function () {
            const parent = this.closest('.ft-col');
            parent.classList.toggle('active');
        });
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-area"] && !Shopify.designMode) return;
  try {
    
  /* ══ Mosaic pop ══ */
  gsap.fromTo('.mi',
      { opacity: 0, scale: .94 },
      {
          opacity: 1, scale: 1, duration: .9, stagger: .12, ease: 'power2.out',
          scrollTrigger: { trigger: '.mosaic', start: 'top 78%' }
      }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-with-banner-4"] && !Shopify.designMode) return;
  try {
    
   // ── Shop tabs ──
    (function () {
        const tabs = document.querySelectorAll('.shop-tab');
        const panels = document.querySelectorAll('.shop-panel');

        tabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                const idx = this.getAttribute('data-idx');

                tabs.forEach(function (t) { t.classList.remove('active'); });
                panels.forEach(function (p) { p.classList.remove('active'); });

                this.classList.add('active');
                document.querySelector('.shop-panel[data-idx="' + idx + '"]').classList.add('active');
            });
        });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-area"] && !Shopify.designMode) return;
  try {
    
  /* ══ Magnetic CTA button ══ */
  (function () {
      const btn = document.getElementById('revCta');
      if (!btn) return;
      btn.addEventListener('mousemove', e => {
          const r = btn.getBoundingClientRect();
          const x = e.clientX - r.left - r.width / 2;
          const y = e.clientY - r.top - r.height / 2;
          btn.style.transform = `translate(${x * .18}px,${y * .22}px)`;
      });
      btn.addEventListener('mouseleave', () => {
          btn.style.transform = 'translate(0,0)';
          btn.style.transition = 'transform .55s cubic-bezier(.16,1,.3,1),background .35s,color .35s,box-shadow .35s';
      });
      btn.addEventListener('mouseenter', () => {
          btn.style.transition = 'transform .12s linear,background .35s,color .35s,box-shadow .35s';
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-area-10"] && !Shopify.designMode) return;
  try {
    
    /* ══ Services stagger ══ */
    gsap.fromTo('.si',
        { opacity: 0, x: -28 },
        {
            opacity: 1, x: 0, duration: .7, stagger: .09, ease: 'power2.out',
            scrollTrigger: { trigger: '.srv-list', start: 'top 80%' }
        }
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-18"] && !Shopify.designMode) return;
  try {
    
/* ══════════════════════════════════
      HERO — SPLIT SCREEN REVEAL
  ══════════════════════════════════ */
  const hTL = gsap.timeline({ delay: 0.2 });

  hTL
      .to('#hHead0 .hero-eyebrow-inner', { y: '0%', duration: .9, ease: 'power3.out' })
      .to('#hHead0 .hero-headline-inner', {
          y: '0%',
          duration: 1.1,
          ease: 'power3.out',
          stagger: 0.12
      }, '-=.7')
      .to('#hDivider', { width: '100%', duration: .9, ease: 'power2.out' }, '-=.6')
      .to('.hero-cta-row', { opacity: 1, y: 0, duration: .8, ease: 'power2.out' }, '-=.4')
      .to('#hScroll', { opacity: 1, duration: .7, ease: 'power2.out' }, '-=.3');

  ///* ══ HERO CAROUSEL ══ */
  (function () {
      const TOTAL = 3;
      const INTERVAL = 5000;
      let current = 0;
      let timer = null;

      const slides = Array.from({ length: TOTAL }, (_, i) => document.getElementById('hSlide' + i));
      const caps = Array.from({ length: TOTAL }, (_, i) => document.getElementById('hCap' + i));
      const dots = document.querySelectorAll('.hero-dot');
      const currEl = document.getElementById('hscCurr');

      function pad(n) { return String(n + 1).padStart(2, '0') }

      function goTo(next) {
          if (next === current) return;
          const prev = current;

          slides[prev].classList.remove('active');
          caps[prev].classList.remove('active');
          dots[prev].classList.remove('active');

          slides[next].classList.add('active');
          caps[next].classList.add('active');
          dots[next].classList.add('active');

          // ── Headline + eyebrow swap ──
          const heads = Array.from({ length: TOTAL }, (_, i) => document.getElementById('hHead' + i));

          // Animate out — eyebrow + headlines together
          gsap.to(`#hHead${prev} .hero-eyebrow-inner, #hHead${prev} .hero-headline-inner`, {
              y: '-110%',
              opacity: 0,
              duration: 0.5,
              ease: 'power2.in',
              stagger: 0.05,
              onComplete: () => {
                  heads[prev].classList.remove('active', 'exiting');
                  gsap.set(`#hHead${prev} .hero-eyebrow-inner, #hHead${prev} .hero-headline-inner`, { y: '110%', opacity: 1 });
              }
          });
          heads[prev].classList.add('exiting');

          // Animate in — eyebrow first, then headlines
          heads[next].classList.add('active');
          gsap.fromTo(
              `#hHead${next} .hero-eyebrow-inner, #hHead${next} .hero-headline-inner`,
              { y: '110%', opacity: 1 },
              { y: '0%', opacity: 1, duration: 0.85, ease: 'power3.out', stagger: 0.09 }
          );

          // Counter
          gsap.to(currEl, {
              opacity: 0, y: -8, duration: .18, ease: 'power1.in', onComplete: () => {
                  currEl.textContent = pad(next);
                  gsap.to(currEl, { opacity: 1, y: 0, duration: .28, ease: 'power1.out' });
              }
          });

          current = next;
          restartTimer();
      }

      function restartTimer() {
          if (timer) clearInterval(timer);
          timer = setInterval(() => goTo((current + 1) % TOTAL), INTERVAL);
      }

      dots.forEach(d => {
          d.addEventListener('click', () => goTo(parseInt(d.dataset.slide, 10)));
      });

      // Auto-start
      restartTimer();

      // Pause on hover
      document.getElementById('heroLeft').addEventListener('mouseenter', () => { if (timer) clearInterval(timer) });
      document.getElementById('heroLeft').addEventListener('mouseleave', () => restartTimer());
})();

  } catch(e) { console.error(e); }
})();
})();
